// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__c4GA2","slash":"breadcrumbs_slash__-yfA9"};